import { api } from '@api/api2';

export const getCameraProtocols = () => api.v1('get', 'cameras/get-available-types');
